import { defineStore } from "pinia";
import { ref, reactive } from "vue";

export const useNotificacionEditStore = defineStore(
  "notificacionEdit",
  () => {
    const id = ref(0);
    const id_estatus = ref(null);
    const id_cotizaciones = ref(null);
    const id_clientes = ref(null);
    const fad = ref(null);
    const acta_express_extra = ref(null);
    const envio = ref(null);
    const contenido_digital = ref(null);
    const corredurias_id = ref(null);
    const domicilios_id = ref(null);
    const hora_llegada = ref(null);
    const forma_cerciorarse = ref(null);
    const tipo_lugar = ref(null);
    const momento_clave_atendido = ref(null);
    const varios_lugares = ref(null);
    const otro_lugar = ref(null);
    const abierto_publico = ref(null);
    const ingreso_numeros_interiores = ref(null);
    const lugar_final_persona_atendio = ref(null);
    const persona_atendio_sexo = ref(null);
    const persona_atendio_edad = ref(null);
    const persona_atendio_estatura = ref(null);
    const persona_atendio_cabello = ref(null);
    const persona_atendio_complexion = ref(null);
    const momento_clave_persona_atendio = ref(null);
    const domicilio_señalado = ref(null);
    const domicilio_persona_buscada = ref(null);
    const declaracion_domicilio_negativo = ref(null);
    const recibio_comunicacion = ref(null);
    const instructivo_firmado = ref(null);
    const persona_atendio_nombre_proporcionado = ref(null);
    const persona_atendio_nombre = ref(null);
    const persona_atendio_identificacion = ref(null);
    const persona_atendio_identificacion_tipo_documento = ref(null);
    const persona_atendio_identificacion_numero = ref(null);
    const procedimiento_notificacion = ref(null);
    const hora_notificacion = ref(null);
    const persona_atendio_manifestaciones_realizadas = ref(null);
    const persona_atendio_manifestaciones = ref(null);
    const reporte_fotografico = ref(null);
    const validaEnvio = ref(null);
    const pagado = ref(null);
    const forma_pago = ref(null);
    const precio_total = ref(0);

    const solicitantes = ref([]);
    const documentos = ref([]);
    const notificados = ref([]);
    const clausulas_confirmacion = ref([]);

    const currentComponentValues = reactive({
      Cotizacion: false,
      Ubicacion: false,
      Solicitantes: false,
      Documentos: false,
      Extras: false,
      Pago: false,
      EnvioDomicilio: false,
      ComplementaNotificado: false,
      ComplementaSolicitantes: false,
      EntregaDocumentos: false,
      FirmaDocumentos: false,
      Diligencia: false,
      Actas: false,
      Expediente: false,
      Terminado: false,
      EsperaValidacion: false,
    });

    const cotizacion = reactive({
      id: 0,
      cupones_id: 0,
      infoCupon: {
        id: null,
        isValid: null,
        message: null,
        tipo: null,
        descuento: null,
      },
    });

    return {
      id,
      id_estatus,
      id_cotizaciones,
      id_clientes,
      fad,
      acta_express_extra,
      envio,
      contenido_digital,
      corredurias_id,
      domicilios_id,
      hora_llegada,
      forma_cerciorarse,
      tipo_lugar,
      momento_clave_atendido,
      varios_lugares,
      otro_lugar,
      abierto_publico,
      ingreso_numeros_interiores,
      lugar_final_persona_atendio,
      persona_atendio_sexo,
      persona_atendio_edad,
      persona_atendio_estatura,
      persona_atendio_cabello,
      persona_atendio_complexion,
      momento_clave_persona_atendio,
      domicilio_señalado,
      domicilio_persona_buscada,
      declaracion_domicilio_negativo,
      recibio_comunicacion,
      instructivo_firmado,
      persona_atendio_nombre_proporcionado,
      persona_atendio_nombre,
      persona_atendio_identificacion,
      persona_atendio_identificacion_tipo_documento,
      persona_atendio_identificacion_numero,
      procedimiento_notificacion,
      hora_notificacion,
      persona_atendio_manifestaciones_realizadas,
      persona_atendio_manifestaciones,
      reporte_fotografico,
      validaEnvio,
      pagado,
      forma_pago,
      precio_total,
      solicitantes,
      documentos,
      notificados,
      clausulas_confirmacion,
      currentComponentValues,
      cotizacion
    };
  },
  {
    persist: true,
  },
);
